import { Stack, TextField } from '@mui/material'
import type { EventSettings } from '../api/generated/EventSettings'

export type EventDates = Pick<EventSettings, 'starts_on' | 'ends_on'>

const inputValue = (e: Event) => (e.target as HTMLInputElement).value || null
const shrink = { shrink: true }

/** First and last days of the event, both or neither; a first day after the last one moves it. */
export function EventDateFields({
  value,
  onChange,
  required = false,
}: {
  value: EventDates
  onChange: (value: EventDates) => void
  required?: boolean
}) {
  const changeStart = (startsOn: string | null) =>
    onChange({
      starts_on: startsOn,
      ends_on: startsOn && (!value.ends_on || value.ends_on < startsOn) ? startsOn : value.ends_on,
    })
  return (
    <Stack direction="row" spacing={2}>
      <TextField
        label="Premier jour"
        type="date"
        required={required || Boolean(value.ends_on)}
        sx={{ flex: 1 }}
        slotProps={{ inputLabel: shrink }}
        value={value.starts_on ?? ''}
        onInput={(e) => changeStart(inputValue(e))}
      />
      <TextField
        label="Dernier jour"
        type="date"
        required={required || Boolean(value.starts_on)}
        sx={{ flex: 1 }}
        slotProps={{ inputLabel: shrink, htmlInput: { min: value.starts_on ?? undefined } }}
        value={value.ends_on ?? ''}
        onInput={(e) => onChange({ ...value, ends_on: inputValue(e) })}
      />
    </Stack>
  )
}
